import { atom, useRecoilState, useRecoilValue } from 'recoil';
import type { FilterOption } from '../../../../shared/types';

const searchQueryAtom = atom<string>({
    key: 'search-query',
    default: ''
});

export default function useFilterOptionsBySearchQuery<T extends FilterOption>(options: T[]) {
    const query = useRecoilValue(searchQueryAtom);
    const filteredOptions = options.filter((option) =>
        option.displayName.toLocaleLowerCase().includes(query.toLocaleLowerCase())
    );

    return filteredOptions;
}

export function useSearchQuery() {
    return useRecoilState(searchQueryAtom);
}
